import { render } from "./FourthLevelProject.vue?vue&type=template&id=59a3274b"
import script from "./FourthLevelProject.vue?vue&type=script&lang=js"
export * from "./FourthLevelProject.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__